import { get } from 'lodash';

export default ({ currencyCode = '', products = [] } = {}, pnrModel, userProfile, seatExitRow) => {
  const {
    cart,
    storefront,
  } = pnrModel;

  const {
    travelerCollection,
  } = cart;

  const availableChubbUs = storefront === 'en-us' || storefront === 'es-us';
  let clubpremierIDP = null;
  let balancePoints = null;
  let metricPointsValue = 0;
  let  metricPointsValueUPG = 0;
  let ancillarieType = null;
  let clubpremierIDPSeat = null;
  let balancePointsSeat = null;
  let quantityAncillerie = 0;

  if (travelerCollection) {
    clubpremierIDP = userProfile && userProfile.ffNumber;
    balancePoints = userProfile && userProfile.account && userProfile.account.balance;

    const ancillariesLength = get(travelerCollection[0], 'ancillaries.ancillaries.length', 0);
    const travelerCollectionPath = travelerCollection[0].ancillaries.ancillaries;

    if (ancillariesLength !== 0) {
      if (travelerCollectionPath !== undefined) {
        travelerCollectionPath.map(ancillaryItem => {
          if (ancillaryItem?.ancillary) {
            ancillarieType = ancillaryItem.ancillary.type;
          }
        });
      }
    } else {
      if (userProfile !== undefined && userProfile.account !== undefined) {
        clubpremierIDPSeat = userProfile.ffNumber;
        balancePointsSeat = userProfile.account.balance;
      }
    }
    if (ancillarieType === 'UPG') {
      // Este if es para el upgrade
      if (travelerCollection !== undefined) {
        travelerCollection.forEach(travelerItem => {
          if (travelerItem.ancillaries.ancillaries) {
            travelerItem.ancillaries.ancillaries.forEach(ancillariesItem => {
              if (ancillariesItem && ancillariesItem.isPaid === false) {
                if (ancillariesItem.ancillary.ancillaryOffer && ancillariesItem.ancillary.ancillaryOffer.ancillary.redeemedCP === true) {
                  const metricPointsValueUPGAux = ancillariesItem.ancillary.ancillaryOffer.ancillary.currency.totalCPPoints;
                  products.forEach(productItem => {
                    if (productItem.variant === 'Club Premier') {
                      metricPointsValueUPG = productItem.quantity * metricPointsValueUPGAux;
                    }
                  });
                } else if (ancillariesItem.ancillary.ancillaryOffer && ancillariesItem.ancillary.ancillaryOffer.ancillary.redeemedCP === false) {
                  metricPointsValueUPG = 0;
                }
              }
            });
          }
        });
      }
    } else {
      // Este if es para todos los demas ancillaries
      if (travelerCollection !== undefined && ancillarieType !== '09T') {
        travelerCollection.forEach(travelerItem => {
          if (seatExitRow) {
            if (seatExitRow.redeemedCP === true) {
              metricPointsValue = seatExitRow.totalCPPoints;
            }
          } else {
            if (travelerItem.ancillaries.ancillaries) {
              travelerItem.ancillaries.ancillaries.forEach(ancillariesItem => {
                if (ancillariesItem && ancillariesItem.isPaid === false) {
                  if (ancillariesItem?.ancillary?.type !== 'SVI' && !availableChubbUs) {
                    quantityAncillerie += 1;
                    products[0].quantity = quantityAncillerie;
                  }
                  if (ancillariesItem.ancillary.redeemedCP === true) {
                    metricPointsValue += ancillariesItem.ancillary.points;
                  }
                }
              });
            }
          }
        });
      }
    }
  }

  localStorage.removeItem('clubpremierIDP');
  localStorage.removeItem('pointsCP');

  return  (clubpremierIDP !== null || clubpremierIDPSeat !== null) ? {
    event: 'addToCart',
    ticketNumber: '',
    pointsValue: metricPointsValue === 0 ? metricPointsValueUPG : metricPointsValue,
    pointsCP: balancePoints !== null ? balancePoints : balancePointsSeat,
    clubpremierIDP: clubpremierIDP !== null ? clubpremierIDP : clubpremierIDPSeat,
    ecommerce: {
      affiliation: 'MYB',
      currencyCode,
      add: {
        products,
      },
    },
  } : {
    event: 'addToCart',
    ecommerce: {
      currencyCode,
      add: {
        products,
      },
    },
  };
};
